import { useContext, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Rating,
  Tooltip,
  Typography,
} from "@mui/material";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import calendarIcon from "../../../assets/images/calendar-icon.png";
import chatIcon from "../../../assets/images/chat-icon.png";
import locationIcon from "../../../assets/images/location-white-icon.png";
import moment from "moment";
import { useSelector } from "react-redux";
import { IStoreValue, RentalItem } from "utils/types";
import ConfirmationModal from "./ConfirmationModal";
import gemArrow from "assets/images/gem-arrow.png";
import EquipmentCalender from "../../Calendar/EquipmentCalender";
import { convertTimeZoneShortName, customRound } from "utils/commonFxns";
import { orderContext } from "./EquipmentOrders";
import momentTimezone from "moment-timezone";
import UsCurrencyFormat from "./UsCurrencyFormat";
import gpsIconWhite from "../../../assets/images/gps-icon-white.png";
import ShowReviewModal from "components/common/ShowReviewModal";
import dummyProfile from "assets/images/dummy-profile-pic.jpeg";
import CountdownTimer from "components/common/CountDownTimer";
import DateTimeLabel from "./DateTimeLabel";
const RentalRequests = ({
  rentalRequestData,
  handleDetailModalOpen,
  handleDetailModalData,
  handleNotificationRedirection,
  handleModalConfirmation,
  setActionType,
  loading,
  isConfirmationOpen,
  handleConfirmationClose,
  handleConfirmationOpen,
  handlePagination,
  loadMore,
  handleMapRedirection,
  pageNo,
  setPageNo,
  handleRentalYardRedirection,
}) => {
  const { handleGPSNavigation, handleProToolsNavigation } =
    useContext(orderContext);
  const AuthUserId = useSelector(
    (state: IStoreValue) => state.equipmentReducer.Authuser
  );
  // const AuthProfile = useSelector(
  //   (state: IStoreValue) => state.equipmentReducer.AuthProfileData
  // );
  const [isCalendarPopupOpen, setIsCalendarPopupOpen] =
    useState<boolean>(false);
  const [activeEquip, setActiveEquip] = useState<any>({});
  const handleCalenderPopupOpen = () => setIsCalendarPopupOpen(true);
  const handleCalenderPopupClose = () => setIsCalendarPopupOpen(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  // const [pageNo, setPageNo] = useState<number>(1);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState<boolean>(false);
  const handleReviewModalOpen = () => setIsReviewModalOpen(true);
  const handleReviewModalClose = () => setIsReviewModalOpen(false);

  const HandleRentAgain = (ActiveEquip: any) => {
    window.location.href =
      "/detail/" + ActiveEquip["owner_id"] + "/" + ActiveEquip["equip_id"];
  };

  const handleReviewClick = (element) => {
    handleReviewModalOpen();
    setActiveEquip(element);
  };

  return (
    Object.entries(rentalRequestData).length > 0 &&
    rentalRequestData?.data?.length > 0 && (
      <Box>
        <Box>
          <Typography
            variant="h6"
            sx={{
              color: "#faa61a !important",
              fontFamily: "GothamBold !important",
              mb: 1,
              mt: 2,
              fontSize: {
                xs: "20px",
                sm: "26px",
                md: "32px",
                lg: "36px",
                xl: "40px",
              },
              textTransform: "uppercase",
            }}
          >
            {rentalRequestData?.title}
          </Typography>
        </Box>
        <Box
          sx={{
            // mt:4,
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr",
              md: "repeat(2, 1fr)",
              lg: "repeat(2, 1fr)",
              xl: "repeat(2, 1fr)",
            },
            gap: "1.5rem",
            rowGap: "2rem",
            alignItems: "center",
            pt: "1rem",
          }}
        >
          {rentalRequestData.data.length > 0 &&
            rentalRequestData.data.map((element: RentalItem) => {
              const devilry = element["delivery_charges"] * 2;
              const minimun = element["minimum_delivery_fees"];
              const totalMi = devilry + minimun;
              const _changeInTotal = (totalMi / 100) * 10;
              const refunded_protection =
                element["refunded_protection"] != undefined ||
                element["refunded_protection"] != ""
                  ? element["refunded_protection"]
                  : "";
              const grand_total =
                element["protection_fees_refunded"] != "1"
                  ? element["admin_commission"] != null
                    ? element["total_price"] +
                      element["equipment_protection_fees"] +
                      _changeInTotal +
                      element["admin_commission"]
                    : element["total_price"] +
                      element["equipment_protection_fees"]
                  : element["admin_commission"] != null
                  ? element["total_price"] -
                    (element["order_status"] == "order_canceled"
                      ? element["security_deposit"]
                      : 0) +
                    _changeInTotal +
                    element["admin_commission"] +
                    (element["protection_fees_refunded"] == "1"
                      ? element["equipment_protection_fees"] -
                        (refunded_protection == ""
                          ? element["equipment_protection_fees"]
                          : refunded_protection)
                      : 0)
                  : element["total_price"];
              const background =
                "linear-gradient(180deg, hsla(0, 0%, 100%, .1), hsla(0, 0%, 100%, 0))";
              const filter = "grayscale(100%)";
              const isOwner = AuthUserId === element?.owner_id;
              return (
                <Box
                  sx={{
                    // background: element?.request_status === "4"?background:"#484840",
                    background: "#484840",
                    paddingTop: "1.6rem !important",
                    filter: element?.request_status === "4" ? filter : "",
                    pointerEvents:
                      element?.request_status === "4" ? "none" : "",
                    borderRadius: "10px",
                    boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.5)",
                    padding: "1rem",
                    position: "relative",
                    height: {
                      xs: "auto",
                      sm: "auto",
                      md: "100%",
                      lg: "100%",
                      xl: "100%",
                    },
                    boxSizing: "border-box",
                    width: "100%",
                    // mt:2
                  }}
                  key={element.order_id}
                >
                  {element?.request_type !== "main_order" && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "-15px",
                        left: "20px",
                        padding: "5px 10px",
                        color: "#fff",
                        background: "#149247",
                        fontFamily: "Montserrat !important",
                        fontWeight: "600",
                        borderRadius: "7px",
                        fontSize: "14px",
                        textTransform: "uppercase",
                        width: "fit-content",
                        mb: 1,
                      }}
                    >
                      {/* Order Extend Request */}
                      Rental Extend Request
                    </Box>
                  )}
                  {/* Image Section */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "1rem",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "1rem",
                      }}
                    >
                      <Box
                        component={"img"}
                        src={element?.thumbnail}
                        sx={{
                          width: {
                            xs: "50px",
                            sm: "65px",
                            md: "70px",
                            lg: "75px",
                            xl: "80px",
                          },
                          height: {
                            xs: "38px",
                            sm: "40px",
                            md: "45px",
                            lg: "50px",
                            xl: "55px",
                          },
                          objectFit: "cover",
                          borderRadius: "5px",
                          border: "2px solid #faa61a",
                          boxShadow: "0px 0px 8px 0px rgba(0,0,0,0.5)",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          if (isOwner) {
                            handleRentalYardRedirection(element?.equip_id);
                          } else {
                            HandleRentAgain(element);
                          }
                        }}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "6px",
                        }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            fontWeight: "700",
                            fontSize: {
                              xs: "18px",
                              sm: "18px",
                              md: "20px",
                              lg: "23px",
                              xl: "24px",
                            },
                            fontFamily: "Montserrat !important",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            if (isOwner) {
                              handleRentalYardRedirection(element?.equip_id);
                            } else {
                              HandleRentAgain(element);
                            }
                          }}
                        >
                          {element?.make
                            ? element?.make.length > 20
                              ? element?.make.slice(0, 20) + "..."
                              : element?.make
                            : "N/A"}
                        </Typography>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Typography
                            sx={{
                              color: "#fff",
                              fontSize: {
                                xs: "14px",
                                sm: "14px",
                                md: "14px",
                                lg: "14px",
                                xl: "15px",
                              },
                            }}
                          >
                            Order #
                            {element?.request_type === "extend_order"
                              ? element?.parent_order_id
                              : element?.order_id}
                          </Typography>
                          <Typography
                            sx={{
                              color: "#faa61a",
                              textDecorationLine: "underline",
                              textDecorationColor: "#faa61a",
                              fontSize: {
                                xs: "14px",
                                sm: "14px",
                                md: "14px",
                                lg: "14px",
                                xl: "15px",
                              },
                              cursor: "pointer",
                              fontFamily: "Arial",
                            }}
                            onClick={() => {
                              handleDetailModalData(element, "request");
                              handleDetailModalOpen();
                            }}
                          >
                            Details
                          </Typography>
                          <Typography
                            sx={{
                              color: "#faa61a",
                              textDecorationLine: "underline",
                              textDecorationColor: "#faa61a",
                              fontSize: {
                                xs: "14px",
                                sm: "14px",
                                md: "14px",
                                lg: "14px",
                                xl: "15px",
                              },
                              cursor: "pointer",
                              fontFamily: "Arial",
                            }}
                            onClick={handleProToolsNavigation}
                          >
                            Tools
                          </Typography>
                          {isOwner && element?.connected_status === "1" && (
                            <Tooltip title={"GPS Locate"} placement="top" arrow>
                              <Box
                                component={"img"}
                                src={gpsIconWhite}
                                sx={{
                                  ml: 0.5,
                                  cursor: "pointer",
                                  width: "22px",
                                  height: "22px",
                                  objectFit: "contain",
                                  marginTop: "-6px",
                                }}
                                onClick={(event) => {
                                  event.preventDefault();
                                  handleGPSNavigation(element);
                                }}
                              />
                            </Tooltip>
                          )}
                        </Box>
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        alignItems: "center",
                        position: "absolute",
                        top: "-15px",
                        right: "14px",
                        backgroundColor: "#48473F",
                        boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.5)",
                        px: 1.3,
                        py: 0.5,
                        borderRadius: 1.5,
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#fff",
                          fontFamily: "Montserrat !important",
                          fontSize: {
                            xs: "12px",
                            sm: "14px",
                            md: "14px",
                            lg: "14px",
                            xl: "14px",
                          },
                          fontWeight: "400",
                          textTransform: "uppercase",
                        }}
                      >
                        {isOwner ? "You'll Earn" : "Pending"}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#faa61a",
                          fontFamily: "Montserrat !important",
                          fontSize: {
                            xs: "14px",
                            sm: "16px",
                            md: "17px",
                            lg: "17px",
                            xl: "18px",
                          },
                          fontWeight: "700",
                        }}
                      >
                        {isOwner ? (
                          <UsCurrencyFormat
                            amount={
                              element?.total_price - element?.security_deposit
                            }
                          />
                        ) : (
                          <UsCurrencyFormat amount={grand_total} />
                        )}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ padding: { sm: "0", md: "0.5rem 1rem" } }}>
                    <Box
                      sx={{
                        background: "#2d2d2d",
                        borderRadius: 2,
                        padding: 2,
                        display: "flex",
                        flexDirection: "column",
                        gap: 1.5,
                        mt: 2,
                        mb: 2,
                      }}
                    >
                      {/* Detail Section */}
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "1rem",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "0px",
                          }}
                        >
                          <Typography
                            sx={{
                              color: "#fff",
                              fontSize: {
                                xs: "16px",
                                sm: "16px",
                                md: "16px",
                                lg: "16px",
                                xl: "16px",
                              },
                              textTransform: "uppercase",
                              fontFamily: "Arial !important",
                              fontWeight: 750,
                            }}
                          >
                            Start
                          </Typography>
                          <Typography
                            sx={{
                              color: "#faa61a",
                              textDecoration: "underline",
                              textDecorationColor: "#faa61a",
                              fontSize: {
                                xs: "14px",
                                sm: "14px",
                                md: "15px",
                                lg: "15px",
                                xl: "15px",
                              },
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setActiveEquip(element);
                              handleCalenderPopupOpen();
                            }}
                          >
                            {/* {(() => {
                            const dateTime = element?.timezone
                              ? momentTimezone.tz(
                                  `${element.start_date} ${element.start_time}`,
                                  element.timezone
                                )
                              : moment.utc(
                                  `${element.start_date} ${element.start_time}`
                                );

                            // Get the current date in the same timezone
                            const now = element?.timezone
                              ? momentTimezone().tz(element.timezone)
                              : moment.utc();

                            // Format actual date string for fallback
                            const formattedDate = dateTime.format("MM/DD/YYYY");
                            const time = dateTime.format("hh:mm a (z)");

                            // Compare just the date parts
                            let dateLabel = formattedDate;
                            if (dateTime.isSame(now, "day")) {
                              dateLabel = "Today";
                            } else if (
                              dateTime
                                .clone()
                                .startOf("day")
                                .diff(now.clone().startOf("day"), "days") === 1
                            ) {
                              dateLabel = "Tomorrow";
                            }

                            return (
                              <>
                                {dateLabel}
                                <br />
                                {time}
                              </>
                            );
                          })()} */}
                            <DateTimeLabel
                              startDate={element.start_date}
                              startTime={element.start_time}
                              timezone={element.timezone}
                            />
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "0px",
                          }}
                        >
                          <Typography
                            sx={{
                              color: "#fff",
                              fontSize: {
                                xs: "16px",
                                sm: "16px",
                                md: "16px",
                                lg: "16px",
                                xl: "16px",
                              },
                              textTransform: "uppercase",
                              fontFamily: "Arial !important",
                              fontWeight: 750,
                            }}
                          >
                            End
                          </Typography>
                          <Typography
                            sx={{
                              color: "#faa61a",
                              textDecoration: "underline",
                              textDecorationColor: "#faa61a",
                              fontSize: {
                                xs: "14px",
                                sm: "14px",
                                md: "15px",
                                lg: "15px",
                                xl: "15px",
                              },
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setActiveEquip(element);
                              handleCalenderPopupOpen();
                            }}
                          >
                            {/* {(() => {
                            const fullDateTime = element?.timezone
                              ? convertTimeZoneShortName(
                                  momentTimezone
                                    .tz(
                                      `${element.end_date} ${element.end_time}`,
                                      element?.timezone
                                    )
                                    .format("MM/DD/YYYY hh:mm a (z)")
                                )
                              : moment(
                                  `${element.end_date} ${element.end_time}`
                                ).format("MM/DD/YYYY hh:mm a (UTC)");
                            const [date, ...rest] = fullDateTime.split(" ");
                            const time = rest.join(" ");

                            return (
                              <>
                                {date}
                                <br />
                                {time}
                              </>
                            );
                          })()} */}
                            <DateTimeLabel
                              startDate={element.end_date}
                              startTime={element.end_time}
                              timezone={element.timezone}
                            />
                          </Typography>
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "0px",
                        }}
                      >
                        {/* <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "8px",
                      }}
                    > */}
                        {/* <Box
                        component={"img"}
                        src={locationIcon}
                        alt=""
                        sx={{
                          width: {
                            xs: "12px",
                            sm: "15px",
                            md: "18px",
                            lg: "20px",
                            xl: "20px",
                          },
                          mt: "2px",
                        }}
                      /> */}
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "baseline",
                              flexDirection: "column",
                              gap: "0px",
                            }}
                          >
                            <Typography
                              sx={{
                                color: "#fff",
                                fontSize: {
                                  xs: "16px",
                                  sm: "16px",
                                  md: "16px",
                                  lg: "16px",
                                  xl: "16px",
                                },
                                textTransform: "uppercase",
                                fontFamily: "Arial !important",
                                fontWeight: 750,
                              }}
                            >
                              {isOwner
                                ? element?.delivery_required === "1"
                                  ? "Deliver to"
                                  : "Renter Pickup"
                                : "Pickup / Delivery"}
                            </Typography>
                            <Typography
                              sx={{
                                color: isOwner ? "#faa61a" : "#faa61a",
                                textDecoration: isOwner ? "underline" : "none",
                                textDecorationColor: isOwner
                                  ? "#faa61a"
                                  : "#fff",
                                fontSize: {
                                  xs: "15px",
                                  sm: "15px",
                                  md: "15px",
                                  lg: "15px",
                                  xl: "15px",
                                },
                                cursor: isOwner ? "pointer" : "default",
                              }}
                              onClick={() => {
                                if (isOwner) {
                                  handleMapRedirection(element);
                                }
                              }}
                            >
                              {isOwner
                                ? element?.delivery_required === "1"
                                  ? element?.delivery_address?.slice(0, 50) +
                                    (element?.delivery_address?.length > 50
                                      ? " ..."
                                      : "")
                                  : element?.equip_address?.slice(0, 50) +
                                    (element?.equip_address?.length > 50
                                      ? " ..."
                                      : "")
                                : "Awaiting Approval"}
                            </Typography>
                          </Box>
                        </Box>
                        {/* </Box> */}
                      </Box>
                    </Box>

                    {/* Reviews */}
                    <Box sx={{ padding: { sm: "0", md: "0.5rem 0.5rem" } }}>          
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        // justifyContent: isOwner ? "space-between" : "center",
                        justifyContent: "space-between",
                        gap: "8px",
                      }}
                    >
                      {/* <Box>
                      {isOwner && ( */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.4,
                        }}
                      >
                        <Box
                          component={"img"}
                          src={
                            isOwner
                              ? element?.renter_profile_pic
                              : element?.owner_profile_pic
                          }
                          sx={{
                            background: "#2d2d2d",
                            width: "50px",
                            height: "50px",
                            borderRadius: "50%",
                            border: "1px solid #faa61a",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            objectFit: "cover",
                          }}
                        />
                        <Box>
                          <Typography
                            sx={{
                              color: "#faa61a",
                              fontFamily: "Arial !important",
                              fontSize: { xs: "16px", md: "18px" },
                              textTransform: "capitalize",
                            }}
                          >
                            {isOwner ? element?.renter : element?.owner}
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Rating
                              size="medium"
                              name="customized-5"
                              precision={0.5}
                              value={customRound(
                                element?.[
                                  isOwner
                                    ? "avg_rating_renter"
                                    : "avg_rating_owner"
                                ] || 0
                              )}
                              max={5}
                              emptyIcon={
                                <StarBorderIcon
                                  sx={{ color: "gray" }}
                                  fontSize="inherit"
                                />
                              }
                              readOnly
                              // sx={{
                              //   color:
                              //     element?.avg_rating_renter_count > 0
                              //       ? "#faa61a"
                              //       : "gray",
                              //   fontSize: "1.2rem",
                              //   "& .MuiRating-iconFilled": {
                              //     color: "#faa61a", // filled stars
                              //   },
                              //   "& .MuiRating-iconEmpty": {
                              //     color: "gray", // empty stars
                              //   },
                              //   "& .MuiRating-iconHover": {
                              //     color: "#ff9800", // when hovering
                              //   },
                              // }}
                            />

                            {element?.[
                              isOwner
                                ? "avg_rating_renter_count"
                                : "avg_rating_owner_count"
                            ] > 0 ? (
                              <Typography
                                sx={{
                                  color: "#faa61a",
                                  textDecoration: "underline",
                                  textDecorationColor: "#faa61a",
                                  fontSize: {
                                    xs: "10px",
                                    sm: "12px",
                                    md: "13px",
                                    lg: "14px",
                                    xl: "14px",
                                  },
                                  cursor: "pointer",
                                }}
                                onClick={() => handleReviewClick(element)}
                              >
                                {isOwner ? "Renter" : "Owner"} Review
                              </Typography>
                            ) : (
                              <Typography
                                sx={{
                                  color: "gray",
                                  fontSize: {
                                    xs: "10px",
                                    sm: "12px",
                                    md: "13px",
                                    lg: "14px",
                                    xl: "14px",
                                  },
                                  textDecoration: "underline",
                                  textDecorationColor: "gray",
                                }}
                              >
                                No Reviews Yet
                              </Typography>
                            )}
                            {element?.[
                              isOwner
                                ? "avg_rating_renter_count"
                                : "avg_rating_owner_count"
                            ] > 0 && (
                              <Typography
                                sx={{
                                  fontSize: { xs: "10px", md: "12px" },
                                  color: "#fff",
                                  fontFamily: "Arial !important",
                                  fontWeight: "500",
                                }}
                              >
                                &#40;{" "}
                                {
                                  element?.[
                                    isOwner
                                      ? "avg_rating_renter_count"
                                      : "avg_rating_owner_count"
                                  ]
                                }{" "}
                                {element?.[
                                  isOwner
                                    ? "avg_rating_renter_count"
                                    : "avg_rating_owner_count"
                                ] > 1
                                  ? " Reviews"
                                  : " Review"}{" "}
                                &#41;
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </Box>
                      {/* )}
                    </Box> */}
                      <Tooltip
                        title={`Message ${isOwner ? "Renter" : "Owner"}`}
                        placement="top"
                        arrow
                      >
                        <Box
                          component={"img"}
                          src={chatIcon}
                          alt=""
                          sx={{
                            width: {
                              xs: "30px",
                              sm: "30px",
                              md: "40px",
                              lg: "40px",
                              xl: "40px",
                            },
                            mt: "-1px",
                            cursor: "pointer",
                            objectFit: "contain",
                          }}
                          onClick={() => handleNotificationRedirection(element)}
                        />
                      </Tooltip>
                    </Box>

                    {/* Accept/reject */}
                    <Box
                      sx={{
                        // border: "3px solid #E61A23",
                        borderRadius: "10px",
                        padding: "0.5rem",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "0.5rem",
                        // boxShadow: "0px 0px 6px 0px rgba(0,0,0,0.5)",
                      }}
                    >
                      {isOwner ? (
                        <>
                          {/* <Typography
                          sx={{
                            color: "#fff",
                            fontFamily: "Montserrat !important",
                            fontWeight: "500",
                            fontSize: {
                              xs: "11px",
                              sm: "14px",
                              md: "16px",
                              lg: "18px",
                              xl: "20px",
                            },
                          }}
                        >
                          {element?.renter?.replace(
                            element?.renter[0],
                            element?.renter[0]?.toUpperCase()
                          )}{" "}
                          has requested a rental.
                        </Typography> */}
                          {element?.request_status === "4" ? (
                            <Button
                              sx={{
                                textTransform: "capitalize",
                                background: "#E61A23",
                                color: "#fff",
                                fontFamily: "Montserrat !important",
                                borderRadius: "8px",
                                fontWeight: "800",
                                padding: "7px 15px",
                                fontSize: {
                                  xs: "14px",
                                  sm: "14px",
                                  md: "14px",
                                  lg: "16px",
                                  xl: "16px",
                                },
                                "&:hover": {
                                  background: "#b81118",
                                },
                                mt: 1,
                              }}
                            >
                              Rental Request Has Expired
                            </Button>
                          ) : (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "1rem",
                                width: "100%",
                                mt: 1,
                              }}
                            >
                              <Button
                                sx={{
                                  width: "100%",
                                  textTransform: "capitalize",
                                  background: "#E61A23",
                                  color: "#fff",
                                  fontFamily: "Montserrat !important",
                                  borderRadius: "8px",
                                  fontWeight: "700",
                                  padding: "4px 10px",
                                  fontSize: {
                                    xs: "14px",
                                    sm: "14px",
                                    md: "14px",
                                    lg: "16px",
                                    xl: "16px",
                                  },
                                  "&:hover": {
                                    background: "#b81118",
                                  },
                                }}
                                onClick={() => {
                                  setConfirmationMessage("REJECT");
                                  setActionType("reject");
                                  handleDetailModalData(element);
                                  handleConfirmationOpen();
                                }}
                              >
                                Reject Rental
                              </Button>
                              <Button
                                sx={{
                                  width: "100%",
                                  textTransform: "capitalize",
                                  background: "rgb(20, 146, 71)",
                                  color: "#fff",
                                  fontFamily: "Montserrat !important",
                                  borderRadius: "8px",
                                  fontWeight: "700",
                                  padding: "4px 10px",
                                  fontSize: {
                                    xs: "14px",
                                    sm: "14px",
                                    md: "14px",
                                    lg: "16px",
                                    xl: "16px",
                                  },
                                  "&:hover": {
                                    background: "rgb(46, 125, 50)",
                                  },
                                }}
                                onClick={() => {
                                  setConfirmationMessage("APPROVE");
                                  setActionType("accept");
                                  handleDetailModalData(element);
                                  handleConfirmationOpen();
                                }}
                              >
                                {/* Accept */}
                                Approve Rental
                              </Button>
                            </Box>
                          )}
                        </>
                      ) : (
                        <>
                          {/* <Typography
                          sx={{
                            color: "#fff",
                            fontFamily: "Montserrat !important",
                            fontWeight: "500",
                            fontSize: {
                              xs: "11px",
                              sm: "14px",
                              md: "16px",
                              lg: "18px",
                              xl: "20px",
                            },
                          }}
                        >
                          You have requested a rental.
                        </Typography> */}
                          {element?.request_status === "4" ? (
                            <Button
                              sx={{
                                textTransform: "capitalize",
                                background: "#E61A23",
                                color: "#fff",
                                fontFamily: "Montserrat !important",
                                borderRadius: "8px",
                                fontWeight: "800",
                                padding: "7px 15px",
                                fontSize: {
                                  xs: "14px",
                                  sm: "14px",
                                  md: "14px",
                                  lg: "16px",
                                  xl: "16px",
                                },
                                "&:hover": {
                                  background: "#b81118",
                                },
                                mt: 1,
                              }}
                            >
                              Rental Request Has Expired
                            </Button>
                          ) : (
                            <Button
                              sx={{
                                textTransform: "capitalize",
                                background: "#E61A23",
                                color: "#fff",
                                fontFamily: "Montserrat !important",
                                borderRadius: "8px",
                                fontWeight: "800",
                                padding: "4px 24px",
                                fontSize: {
                                  xs: "14px",
                                  sm: "14px",
                                  md: "14px",
                                  lg: "16px",
                                  xl: "16px",
                                },
                                "&:hover": {
                                  background: "#b81118",
                                },
                                mt: 1,
                              }}
                              onClick={() => {
                                setConfirmationMessage("CANCEL");
                                setActionType("cancel");
                                handleDetailModalData(element);
                                handleConfirmationOpen();
                              }}
                            >
                              Cancel Rental Request
                            </Button>
                          )}
                        </>
                      )}
                    </Box>
                    </Box>
                  </Box>
                  {element?.request_status !== "4" && (
                    <Box>
                      {element?.request_expire_at && !isOwner && (
                        <Box sx={{ color: "#fff", textAlign: "center", mt: 2 }}>
                          <span>Note: </span>
                          <span>
                            {element?.owner?.replace(
                              element?.owner[0],
                              element?.owner[0]?.toUpperCase()
                            )}{" "}
                            has
                          </span>
                          <CountdownTimer
                            expirationDateTime={element["request_expire_at"]}
                            color="#faa61a"
                          />
                          <span>
                            &nbsp;to accept this offer before it is withdrawn
                            automatically
                          </span>
                        </Box>
                      )}
                      {element?.request_expire_at && isOwner && (
                        <Box sx={{ color: "#fff", textAlign: "center", mt: 2 }}>
                          <span>Note: </span>
                          <span>
                            The rental request will automatically cancel if not
                            accepted in next
                          </span>
                          <CountdownTimer
                            expirationDateTime={element["request_expire_at"]}
                            color="#faa61a"
                          />
                        </Box>
                      )}
                    </Box>
                  )}
                </Box>
              );
            })}
        </Box>
        {rentalRequestData.data.length === 0 && (
          <Box
            sx={{
              width: "100%",
              padding: "2rem 1rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontSize: {
                  xs: "14px",
                  sm: "14px",
                  md: "15px",
                  lg: "16px",
                  xl: "18px",
                },
                fontFamily: "Montserrat !important",
                fontWeight: "800",
              }}
            >
              No Records Found!
            </Typography>
          </Box>
        )}
        {/* {rentalRequestData?.total > rentalRequestData?.data?.length && (
          <Box className="pagination-section">
            {loadMore ? (
              <CircularProgress />
            ) : (
              <Box
                className="btn-load-more"
                onClick={() => {
                  setPageNo((prev) => prev + 1);
                  handlePagination("RENTAL REQUESTS", pageNo);
                }}
              >
                {"Load More"}
                <img
                  src={gemArrow}
                  alt="GoEquipMe"
                  className="gem-arrow arrow-load-more"
                />
              </Box>
            )}
          </Box>
        )} */}
        <ConfirmationModal
          isConfirmationOpen={isConfirmationOpen}
          handleConfirmationClose={handleConfirmationClose}
          onConfirm={handleModalConfirmation}
          message={"Are you sure want to " + confirmationMessage + "?"}
          loading={loading}
        />
        <EquipmentCalender
          activeEquip={activeEquip}
          isCalendarPopupOpen={isCalendarPopupOpen}
          handleCalenderPopupClose={handleCalenderPopupClose}
        />
        {isReviewModalOpen && (
          <ShowReviewModal
            isReviewModalOpen={isReviewModalOpen}
            handleReviewModalClose={handleReviewModalClose}
            ownerId={
              AuthUserId === activeEquip?.owner_id
                ? activeEquip?.renter_id
                : activeEquip?.owner_id
            }
            ownerFirstName={
              AuthUserId === activeEquip?.owner_id
                ? activeEquip?.renter
                : activeEquip?.owner
            }
            ownerProfilePic={
              (AuthUserId === activeEquip?.owner_id
                ? activeEquip?.renter_profile_pic
                : activeEquip?.owner_profile_pic) || dummyProfile
            }
            reviewedBy={
              AuthUserId === activeEquip?.owner_id ? "owner" : "renter"
            }
          />
        )}
      </Box>
    )
  );
};

export default RentalRequests;
